import React, { useState, useEffect } from 'react';
import { Container, Row, Table, Form, Button, Col } from 'react-bootstrap';
import { useHistory } from "react-router-dom";
import axios from 'axios';

const AsistenciasEvento = () => {
    const history = useHistory();
    //codigo para consumir api
    const url = process.env.REACT_APP_SERVER || "http://balanceador-r2-231361140.us-east-2.elb.amazonaws.com:3000";
    const [data, setData] = useState({
        server: "",
        data: []
    });

    const [idEvento, setIdEvento] = useState("");

    const fetchApi = async () => {
        const response = await axios.get(url + '/getById/' + idEvento);
        if (response) {
            var data = response.data.message.result;
            const server = response.data.message.processByGet
            setData({
                data,
                server,
            });
        }
    }

    // useEffect(() => {
    //     fetchApi();
    // }, []);

    //evento de boton 
    function darClick() {
        alert('hola mundo');
    }

    return (
        <Container>
            <Row>
                <h2>Asistencias de Evento</h2>
            </Row>
            <Row>
                <Form>
                    <Col md={6}>
                    <Form.Group className="mb-3" controlId="carnet">
                        <Form.Label>Id Evento</Form.Label>
                        <Form.Control placeholder="#########" 
                            name="idevento"
                            onChange={(e) => setIdEvento(e.target.value)}
                        />
                    </Form.Group>
                    </Col>
                    <Col md={4}>
                        <Button onClick={fetchApi}>
                            Buscar
                        </Button>
                    </Col>
                </Form>
            </Row>
            <Row xs={1} md={3} className="g-4">
                <Table striped bordered hover>
                    <thead>
                        <tr>
                            <th>Carne</th>
                            <th>Estudiante</th>
                            <th>Fecha</th>
                            <th>Servidor</th>
                            <th>Imagen</th>
                            {/* <th>Accion</th> */}
                        </tr>
                    </thead>
                    <tbody>
                        {!data.data ? 'cargando...' : data.data.map((todo, index) => (
                            <tr key={todo.idAsistencia}>
                                <td>{todo.carnet}</td>
                                <td>{todo.estudiante}</td>
                                <td>{todo.fecha}</td>
                                <td>{todo.servidor}</td>
                                <td>
                                    <img src={todo.imageURL}> 
                                    </img>
                                </td>
                                {/* <td>
                                    <Button onClick={() => history.push('/report/' + todo._id)}>
                                        Ver Reporte
                                    </Button>
                                </td> */}
                            </tr>
                        ))}
                    </tbody>
                </Table>
            </Row>
            <Row>
                <h3>
                    {data.server}
                </h3>
            </Row>
        </Container>
    )

    /*return (
        <Row xs={1} md={3} className="g-4">
        {Array.from({ length: 5 }).map((_, idx) => (
          <Col>
            <Card>
              <Card.Body>
                <Card.Title>Card title</Card.Title>
                <Card.Text>
                 texto que se agregara aca 
                </Card.Text>
              </Card.Body>
            </Card>
          </Col>
        ))}
      </Row>
    )*/
}

export default  AsistenciasEvento;
